export const api_url = {
  API_URL: process.env.REACT_APP_API_URL || 'https://api.secureivs.eu/api/v1/',
};
